import { motion } from "framer-motion";

/** Masked line-by-line reveal. Pass an array of strings as `lines`. */
export default function MaskedLines({ lines, className = "", delay = 0, testid }) {
  return (
    <span className={className} data-testid={testid}>
      {lines.map((l, i) => (
        <span key={i} className="line-mask">
          <motion.span
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, ease: [0.2, 0.8, 0.2, 1], delay: delay + i * 0.12 }}
          >
            {l}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
